<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="internships-students"
            :items="tableData"
            :fields="studentFields">
            <template #options>
                <div class="settings">
                    <b-form-group
                        class="internship-tag-select"
                        label-for="internship-tag-selector"
                        label="label">
                        <b-form-select
                            class="apprentice-primary-select"
                            v-model="selectedTag"
                            :options="selectTagData">
                        </b-form-select>
                    </b-form-group>
                    <b-form-group
                        class="internship-group-select"
                        v-if="selectedTag !== null"
                        label-for="internship-tag-selector"
                        :label="$t('internship.group')">
                        <b-form-select
                            class="apprentice-primary-select"
                            v-model="selectedGroup"
                            :options="selectGroupData">
                        </b-form-select>
                    </b-form-group>
                </div>
            </template>

            <template v-slot:cell(internshipAgreement)="data">
                <b-button
                    class="btn-file-alt remove-icon-margin"
                    v-if="data.item.internshipAgreement"
                    variant="primary-icon-only"
                    @click="downloadSignedInternshipAgreement(data.item.internshipAgreement)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
export default {
    name: 'design-2021-internships-index-students-tab-component',
    props: ['internshipTagsIn'],
    data() {
        return {
            internshipTags: this.internshipTagsIn,
            selectedTag: null,
            studentsForTag: null,
            selectedGroup: null,
            studentFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'internship',
                    label: this.$t('internship.internship'),
                },
                {
                    key: 'accepted',
                    label: this.$t('internship.approved'),
                },
                {
                    key: 'internshipAgreement',
                    label: this.$t('internship.internship_agreement'),
                },
            ],
        };
    },
    computed: {
        selectTagData() {
            let array = this.internshipTags.map((tag) => {
                return {
                    value: { id: tag.id, name: tag.name, groups: [...tag.las_groups, ...tag.las_main_groups] },
                    text: tag.name,
                };
            });
            array.unshift({ value: null, text: this.$t('internship.choose_label') });
            return array;
        },
        selectGroupData() {
            if (this.selectedTag) {
                let allStudents = [];
                let array = this.fillStudentsForTag();
                array.unshift({ value: null, text: this.$t('internship.choose_group') });
                return array;
            } else {
                return [];
            }
        },
        tableData() {
            if (this.selectedTag) {
                if (this.selectedGroup) {
                    return this.selectedGroup.students.map((student) => {
                        let internship = student.user.internships
                            ? student.user.internships.find(function (internship2) {
                                  return internship2.internship_tags.find((tag) => tag.id === this.id);
                              }, this.selectedTag)
                            : null;
                        let internshipName = internship ? internship.name : null;
                        let accepted = internship ? internship.pivot.accepted : null;
                        let internshipAgreement =
                            internship?.signed_internship_agreements?.find(
                                (agreement) => agreement.user_id === student.user_id,
                            )?.file.path ?? null;
                        return {
                            id: student.user_id,
                            name: student.user.full_name,
                            internship: internshipName,
                            accepted: accepted,
                            internshipAgreement: internshipAgreement,
                        };
                    });
                } else {
                    this.fillStudentsForTag();
                    return this.studentsForTag.map((student) => {
                        let internship = student.user.internships
                            ? student.user.internships.find(function (internship2) {
                                  return internship2.internship_tags.find((tag) => tag.id === this.id);
                              }, this.selectedTag)
                            : null;
                        let internshipName = internship ? internship.name : null;
                        let accepted = internship ? internship.pivot.accepted : null;
                        let internshipAgreement =
                            internship?.signed_internship_agreements?.find(
                                (agreement) => agreement.user_id === student.user_id,
                            )?.file.path ?? null;
                        return {
                            id: student.user_id,
                            name: student.user.full_name,
                            internship: internshipName,
                            accepted: accepted,
                            internshipAgreement: internshipAgreement,
                        };
                    });
                }
            } else {
                let allStudents = [];
                this.internshipTags.forEach((tag) => {
                    let groups = [...tag.las_groups, ...tag.las_main_groups];
                    groups.forEach((group) => {
                        allStudents.push(group.students);
                    });
                });

                let flatAllStudents = allStudents.flat();
                let distinctStudents = [];
                flatAllStudents.map((student) => {
                    if (!distinctStudents.find((s) => s.user_id === student.user_id)) {
                        distinctStudents.push(student);
                    }
                });

                return distinctStudents.map((student) => {
                    let internship = student.user.internships ? student.user.internships.length : 0;
                    return {
                        id: student.user_id,
                        name: student.user.full_name,
                        internship: internship,
                        accepted: null,
                        internshipAgreement: null,
                    };
                });
            }
        },
    },
    methods: {
        fillStudentsForTag() {
            let allStudents = [];
            let array = this.selectedTag.groups.map((group) => {
                allStudents.push(group.students);
                return {
                    value: { name: group.name, students: group.students },
                    text: group.name,
                };
            });
            let flatAllStudents = allStudents.flat();
            let distinctStudents = [];
            flatAllStudents.map((student) => {
                if (!distinctStudents.find((s) => s.user_id === student.user_id)) {
                    distinctStudents.push(student);
                }
            });
            this.studentsForTag = distinctStudents;

            return array;
        },
        downloadSignedInternshipAgreement(path) {
            window.open(path, '_blank');
        },
    },
};
</script>

<style scoped lang="scss">
.internships-students ::v-deep {
    .apprentice-table-header {
        align-items: flex-end;
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }

    .apprentice-table-filters {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
    }
}

.settings {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
    justify-content: flex-end;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');

    .form-group {
        &:not(:first-child) {
            margin-top: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .form-group,
    select {
        width: 100%;
        margin-bottom: 0;
        flex: 1 0 100%;
    }

    select {
        padding-right: 35px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .internships-students ::v-deep {
        .apprentice-table-header {
            flex-direction: row;
        }

        .apprentice-table-filters,
        .options {
            flex: 0 0 auto;
        }

        .apprentice-table-filters {
            margin-bottom: 0;

            .search {
                width: 200px;
            }
        }
    }

    .settings {
        .form-group {
            max-width: 134px;
        }

        .form-group,
        select {
            flex: 0 0 auto;
            width: auto;
        }

        .form-group {
            &:not(:first-child) {
                margin-top: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .settings {
        .form-group {
            max-width: 200px;
        }
    }
}
</style>
